import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule, ErrorHandler } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatProgressBarModule} from '@angular/material/progress-bar';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { DateAdapter, MAT_DATE_FORMATS} from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from './shared/format-datepicker';


import { ValidationPassLen } from './pipe/validation-pass-len.pipe';
import { ValidationPassLow } from './pipe/validation-pass-low.pipe';
import { ValidationPassNum } from './pipe/validation-pass-num.pipe';
import { ValidationUidLen } from './pipe/validation-uid-len.pipe';
import { ValidationPassUp } from './pipe/validation-pass-up.pipe';
import { ValidationUidNum } from './pipe/validation-uid-num.pipe';
import { ValidationPassSc } from './pipe/validation-uid-specialChars.pipe';
import { HostRedirectPipe } from './pipe/host-redirect.pipe';

// Forms
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Main view components
import { IdentityMgtComponent } from './identity-mgt/identity-mgt.component';
import { IdentityMgtClientComponent } from './identity-mgt-client/identity-mgt-client.component';
import { IdentityMgtClientLandingComponent } from './identity-mgt-client-landing/identity-mgt-client-landing.component';
import { ClientUseridComponent } from './identity-mgt-client/client-userid/client-userid.component';
import { ClientPassComponent } from './identity-mgt-client/client-pass/client-pass.component';
import { NewPwdComponent } from './new-pwd/new-pwd.component';
import { NewQuestionComponent } from './new-question/new-question.component';
import { IdentityMgtCesClientComponent } from './identity-mgt-ces-client/identity-mgt-ces-client.component';
import { IdentityMgtCesClientLandingComponent } from './identity-mgt-ces-client-landing/identity-mgt-ces-client-landing.component';
import { CesClientPassComponent } from './identity-mgt-ces-client/ces-client-pass/ces-client-pass.component';
import { CesClientUseridComponent } from './identity-mgt-ces-client/ces-client-userid/ces-client-userid.component';
import { IdentityMgtFsrComponent } from './identity-mgt-fsr/identity-mgt-fsr.component';

// Error Components
import { AccessDeniedComponent } from './error/access-denied/access-denied.component';
import { PageNotFoundComponent } from './error/page-not-found/page-not-found.component';
import { ServiceErrorComponent } from './error/service-error/service-error.component';

// Shared Services
import { PreviousUrlService } from './shared/PreviousUrl.Service';
import { AppInsightsService } from './shared/AppInsights.Service';
import { ErrorHandlerService } from './shared/ErrorHandler.Service';
import { GlobalHeaderComponent } from './global-header/global-header.component';
import { GlobalFooterComponent } from './global-footer/global-footer.component';

// pipes
import { EmailMaskPipe } from './pipe/email-mask.pipe';
import { PhoneMaskPipe } from './pipe/phone-mask.pipe';
import { SSNMaskPipe } from './pipe/ssn-mask.pipe';
import { ForgotService } from './shared/Forgot.Service';
import { IdentityMgtAdvisorComponent } from './identity-mgt-advisor/identity-mgt-advisor.component';
import { AdvisorPassComponent } from './identity-mgt-advisor/advisor-pass/advisor-pass.component';
import { IdentityMgtEbBrokerComponent } from './identity-mgt-eb-broker/identity-mgt-eb-broker.component';
import { IdentityMgtBrokerComponent } from './identity-mgt-broker/identity-mgt-broker.component';
import { BrokerPassComponent } from './identity-mgt-broker/broker-pass/broker-pass.component';
import { NonAppointedComponent } from './identity-mgt-broker/non-appointed/non-appointed.component';
import { AppointedComponent } from './identity-mgt-broker/appointed/appointed.component';
import { IdentityMgtEbGaAmComponent } from './identity-mgt-eb-ga-am/identity-mgt-eb-ga-am.component';
import { IdentityMgtEbEmployerComponent } from './identity-mgt-eb-employer/identity-mgt-eb-employer.component';
import { IdentityMgtConsultantComponent } from './identity-mgt-consultant/identity-mgt-consultant.component';
import { IdentityMgtEppComponent } from './identity-mgt-epp/identity-mgt-epp.component';
import { IdentityMgtBusinessComponent } from './identity-mgt-business/identity-mgt-business.component';
import { IdentityMgtEpacComponent } from './identity-mgt-epac/identity-mgt-epac.component';
import { IdentityMgtRegistrationLandingComponent } from './identity-mgt-registration-landing/identity-mgt-registration-landing.component';
import { IdentityMgtProspectusComponent } from './identity-mgt-prospectus/identity-mgt-prospectus.component';
import { IdentityMgtCesbrokerComponent } from './identity-mgt-cesbroker/identity-mgt-cesbroker.component';

const routes: Routes = [
  // { path: '', component: IdentityMgtComponent },
  { path: '', component: IdentityMgtComponent },
  { path: 'ces', component: IdentityMgtComponent },
  { path: 'ces/broker', component: IdentityMgtCesbrokerComponent},
  { path: 'broker', component: IdentityMgtBrokerComponent},
  { path: 'broker/non-appointed', component: NonAppointedComponent },
  { path: 'broker/appointed', component: AppointedComponent},
  { path: 'fsr', component: IdentityMgtFsrComponent},
  { path: 'c', component: IdentityMgtClientComponent},
  { path: 'client', component: IdentityMgtClientLandingComponent},
  { path: 'client/uid', component: ClientUseridComponent},
  { path: 'client/pass', component: ClientPassComponent},

  { path: 'ces/c', component: IdentityMgtCesClientComponent},
  { path: 'ces/client', component: IdentityMgtCesClientLandingComponent},
  { path: 'ces/client/pass', component: CesClientPassComponent},
  { path: 'ces/client/uid', component: CesClientUseridComponent},
  
  { path: 'cust', component: IdentityMgtRegistrationLandingComponent},
  { path: 'a', component: AdvisorPassComponent},
  { path: 'business', component: IdentityMgtBusinessComponent},
  { path: 'eb', component: IdentityMgtEbBrokerComponent},
  { path: 'ebe', component: IdentityMgtEbEmployerComponent},
  { path: 'ebbga', component: IdentityMgtEbGaAmComponent},
  { path: 'epp', component: IdentityMgtEppComponent},
  { path: 'epac', component: IdentityMgtEpacComponent},
  { path: 'consultant', component: IdentityMgtConsultantComponent},
  { path: 'prospectus', component: IdentityMgtProspectusComponent},
  { path: 'questions', component: NewQuestionComponent},
  { path: 'ces/questions', component: NewQuestionComponent},
  { path: 'createPwd', component: NewPwdComponent},
  { path: 'ces/createPwd', component: NewPwdComponent},
  { path: 'error', component: ServiceErrorComponent },
  { path: '404', component: PageNotFoundComponent},
  { path: '401', component: AccessDeniedComponent},
  { path: '**', redirectTo: '/404'}
];

@NgModule({
  declarations: [
    AppComponent,
    IdentityMgtComponent,
    AccessDeniedComponent,
    PageNotFoundComponent,
    ServiceErrorComponent,
    GlobalHeaderComponent,
    GlobalFooterComponent,
    EmailMaskPipe,
    PhoneMaskPipe,
    SSNMaskPipe,
    ValidationPassLen,
    ValidationPassLow,
    ValidationPassNum,
    ValidationUidLen,
    ValidationUidNum,
    ValidationPassUp,
    ValidationPassSc,
    HostRedirectPipe,
    IdentityMgtClientComponent,
    IdentityMgtClientLandingComponent,
    ClientUseridComponent,
    ClientPassComponent,
    NewPwdComponent,
    NewQuestionComponent,
    IdentityMgtAdvisorComponent,
    AdvisorPassComponent,
    IdentityMgtEbBrokerComponent,
    IdentityMgtBrokerComponent,
    BrokerPassComponent,
    NonAppointedComponent,
    AppointedComponent,
    IdentityMgtEbGaAmComponent,
    IdentityMgtEbEmployerComponent,
    IdentityMgtConsultantComponent,
    IdentityMgtEppComponent,
    IdentityMgtBusinessComponent,
    IdentityMgtEpacComponent,
    IdentityMgtRegistrationLandingComponent,
    IdentityMgtProspectusComponent,
    IdentityMgtCesbrokerComponent,
    IdentityMgtCesClientComponent,
    IdentityMgtCesClientLandingComponent,
    CesClientPassComponent,
    CesClientUseridComponent,
    IdentityMgtFsrComponent,
  ],
  exports: [
    ValidationPassUp,
    ValidationPassLen,
    ValidationPassLow,
    ValidationPassNum,
    ValidationUidLen,
    ValidationUidNum,
    ValidationPassSc,
    HostRedirectPipe
  ],
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
    NgbModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatTooltipModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  providers: [ForgotService, PreviousUrlService, 
  			  {provide: APP_BASE_HREF, useValue : '/forgot/' },
  			  {provide: DateAdapter, useClass: AppDateAdapter},
              {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS},
              {provide: ErrorHandler, useClass: ErrorHandlerService},
               AppInsightsService],
  bootstrap: [AppComponent]
})
export class AppModule { }
